import { views } from "../../Configs/config";
import * as types from "./app.actionTypes";

const initialState = {
  isStateReset: false,
  tableViewData: {
    view: views.MAP,
    filterFlag: false,
    data: [],
    isBookmarkData: false,
    // Search is now URL-driven (the `q` param); the transient isSearchData flag
    // has been retired in favor of deriving search mode from the URL.
    // isGraphCellClicked: false,
    tableTitle: "",
  },
  isHospitalAddedToBookmark: false,
  isGlobalSearchReset: false,
  isBookmarkTable: false,
  view: views.MAP,
  countByProvidernumber: [],
  dataRefetchTrigger: null,
  isTableResetting: false,
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_HOSPITAL_DATA:
      return {
        ...state,
        hospitalData: payload,
      };
    case types.SET_HOSPITALS_DETAILS:
      return {
        ...state,
        tableViewData: {
          ...state.tableViewData, // Preserve existing values
          // Only apply defined fields to avoid overwriting with undefined
          ...Object.fromEntries(
            Object.entries(payload).filter(([_, value]) => value !== undefined)
          ),
        },
      };

    case types.SET_TABLE_RESETTING:
      return {
        ...state,
        isTableResetting: payload,
      };

    case types.GLOBAL_SEARCH_RESET:
      return {
        ...state,
        isGlobalSearchReset: payload,
      };

    case types.IS_BOOKMARK_TABLE:
      return {
        ...state,
        isBookmarkTable: payload,
      };

    case types.VIEW:
      return {
        ...state,
        view: payload,
      };

    case types.ADD_PROVIDER_NUMBERS:
      return {
        ...state,
        countByProvidernumber: [...payload],
      };

    case types.CLEAR_PROVIDER_NUMBERS:
      return {
        ...state,
        countByProvidernumber: [],
      };

    case types.TRIGGER_DATA_REFETCH:
      return {
        ...state,
        dataRefetchTrigger: payload, // Store timestamp to trigger refetch
      };

    case types.RESTORE_STATE_SNAPSHOT:
      return {
        ...state,
        ...(payload?.app || {}),
      };

    default:
      return state;
  }
};
